export const ROLE_IDS = {
  ADMIN: 1,
  PRIVILEGED: 2,
  EDITOR: 3,
  PARTICIPANT: 4,
  SOCIAL: 5,
};
